<style lang="less">
html,body,#app{
  height:100%;
}

#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: -apple-system-font, "Helvetica Neue", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

.app-menu{
  width: 200PX;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
}

.app-container{
  margin-left: 200PX;
}
</style>

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { browser } from '@/lib/ua';

export default {
  name: 'app',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      error: 'error'
    })
  },
  watch: {
    $route() {
      if (window.performance.mark) {
        window.performance.mark('router');
      }
      if (this.$route.meta.authType === 'user' && browser.wx) {
        this.$store.dispatch('wxSign', {
          url: encodeURI(`${location.origin}/live${this.$route.fullPath}`)
        });
      }
    }
  }

};
</script>



// WEBPACK FOOTER //
// App.vue?32b5fe10